import './App.css';
import Navbar from './Components/Navbar';
import { ThemeProvider, createTheme } from '@mui/material';
import Home from './Views/Home';
import { Route, Routes, Navigate } from 'react-router-dom';
import SupplierManagement from './Views/SupplierManagement';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CategoryManagemnet from './Views/CategoryManagemnet';
import AdminPanel from './Views/AdminPanel';
import PetManagement from './Views/PetManagement';
import ItemManagement from './Views/ItemManagement';
import DoctorManagement from './Views/DoctorManagement';
import Billing from './Views/Billing';
import BarcodeGenerator from './Views/BarcodeGenerator';
import Grn from './Views/Grn';
import ReportModule from './Views/ReportModule';
import StockAllocation from './Views/StockAllocation';
import UserSignUp from './Components/UserSignUp';
import UserManagement from './Views/UserManagement';
import StockReturn from './Views/StockReturn';
import Reservations from './Views/Reservations';
import Billhistory from './Views/Billhistory';
import { BRAND } from './constants/brand';

// Set theme on MUI
const theme = createTheme({
  palette: {
    primary: { main: "#000000" },
    secondary: { main: "#50B498", light: "#FF9874" },
    third: { main: "#F7F9F2" },
  },
});

// Get role from localStorage
const userRole = JSON.parse(localStorage.getItem(BRAND.localStorageKey))?.role;

// Role-based route wrapper
const ProtectedRoute = ({ element, roles }) => {
  // Redirect if the user's role is not in the allowed roles
  return roles.includes(userRole) ? element : <Navigate to="/" />;
};

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Navbar />
        <Routes>
          {/* Public route */}
          <Route exact path="/" element={<Home />} />

          {/* Role-based routes */}
          <Route
            exact
            path="/SupplierManagement"
            element={<ProtectedRoute element={<SupplierManagement />} roles={[1, 4]} />}
          />
          {/* <Route
            exact
            path="/Reservations"
            element={<ProtectedRoute element={<Reservations />} roles={[1, 2]} />}
          /> */}
          <Route
            exact
            path="/CategoryManagement"
            element={<ProtectedRoute element={<CategoryManagemnet />} roles={[1,2]} />}
          />
          <Route
            exact
            path="/AdminPanel"
            element={<ProtectedRoute element={<AdminPanel />} roles={[1]} />}
          />
          <Route
            exact
            path="/ItemManagement"
            element={<ProtectedRoute element={<ItemManagement />} roles={[1, 2,4]} />}
          />
          <Route
            exact
            path="/Billing"
            element={<ProtectedRoute element={<Billing />} roles={[1, 2]} />}
          />
          <Route
            exact
            path="/BillHistory"
            element={<ProtectedRoute element={<Billhistory />} roles={[1, 2]} />}
          />
          <Route
            exact
            path="/barcodeGen"
            element={<ProtectedRoute element={<BarcodeGenerator />} roles={[1,2]} />}
          />
          <Route
            exact
            path="/grn"
            element={<ProtectedRoute element={<Grn />} roles={[1, 2]} />}
          />
          <Route
            exact
            path="/StockAllocation"
            element={<ProtectedRoute element={<StockAllocation />} roles={[1, 2]} />}
          />
          <Route
            exact
            path="/ReportModule"
            element={<ProtectedRoute element={<ReportModule />} roles={[1,3]} />}
          />
          <Route
            exact
            path="/StockReturn"
            element={<ProtectedRoute element={<StockReturn />} roles={[1, 4]} />}
          />
          <Route
            exact
            path="/UserManagement"
            element={<ProtectedRoute element={<UserManagement />} roles={[1]} />}
          />
        </Routes>
        <ToastContainer
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          toastStyle={{
            backgroundColor: "#000000",
            color: "white",
          }}
        />
      </ThemeProvider>
    </>
  );
}

export default App;
